import { Channel } from '@/types/channel.types';
import { EventType } from '@/types/projects.types';
import getAllowedProjectTypesForChannel from '../project-types/get-allowed-project-types-for-channel';

type Props = {
  channel: Channel;
  selectedType?: EventType;
};

const convertProjectTypeBasedOnChannelType = ({ channel, selectedType }: Props): EventType => {
  // get the channel's project types
  const allowedProjectTypes = channel ? getAllowedProjectTypesForChannel(channel) : [];

  // If the selectedType is provided and it matches one of the channel's project types, we can use it directly.
  if (selectedType && allowedProjectTypes.includes(selectedType)) {
    return selectedType;
  }

  // Using EventType.Event as a fallback, because it's the one type that both Townhall and Webinar are both allowed to have
  // so just in case (though unlikely) the channel has no type defined, we can safely return EventType.Event
  return allowedProjectTypes?.[0] || EventType.Event;
};

export default convertProjectTypeBasedOnChannelType;
